import * as angular from "angular";
import {IController, IOnChangesObject} from "angular";
import {PackageConfigurationEntity} from "../../models/package-configuration.model";
import {DefaultPackageConfigurationFieldsType} from "../../types/default-package-configuration-fields.type";
import {FieldCategoryType} from "../../types/field-category.type";
import {PackageFieldConfigurationModel} from "../../models/package-field-configuration.model";

export class PackageConfigurationsTableRowComponent implements IController {

  form: any;
  showActions: boolean;
  index: number;
  packageConfiguration: PackageConfigurationEntity;
  packageConfigurationCopy: PackageConfigurationEntity;
  isEditable: boolean | undefined;
  isDefault: boolean;
  configurationPackageItems: string[];
  onPackageConfigurationChanged: Function;
  onEditPackageConfigurationClicked: Function;
  onAddNewFieldClicked: Function;
  onDuplicateConfigurationClicked: Function;


  public defaultGenericFieldNameOptions: DefaultPackageConfigurationFieldsType[];
  public allFieldNameOptions: DefaultPackageConfigurationFieldsType[];
  public readonly fieldCategoryTypesMap: typeof FieldCategoryType = FieldCategoryType;


  constructor() {
    this.allFieldNameOptions = Object.values(DefaultPackageConfigurationFieldsType);
  }

  $onInit() {
    this.setFieldNameOptions(this.packageConfigurationCopy);
  }

  $onChanges(changes: IOnChangesObject) {

    if (changes.packageConfigurationCopy && !changes.packageConfigurationCopy.isFirstChange()) {
      this.setFieldNameOptions(this.packageConfigurationCopy);
    }
  }

  onDeleteField(index: number) {
    const updatedPackageConfiguration = angular.copy(this.packageConfigurationCopy);
    updatedPackageConfiguration.fields.splice(index, 1)
    this.onPackageConfigurationChanged({updatedPackageConfiguration: updatedPackageConfiguration})
  }

  onFieldChanged(index: number, changedField: PackageFieldConfigurationModel) {
    const updatedPackageConfiguration = angular.copy(this.packageConfigurationCopy);
    updatedPackageConfiguration.fields[index] = changedField
    this.onPackageConfigurationChanged({updatedPackageConfiguration: updatedPackageConfiguration})
  }

  private setFieldNameOptions(packageConfiguration: PackageConfigurationEntity) {
    if (!packageConfiguration) return;

    const existingFieldNames = packageConfiguration.fields.map((field) => {
      return field?.name;
    }).filter((f) => f !== undefined);

    this.defaultGenericFieldNameOptions = this.allFieldNameOptions.filter((fn) => !existingFieldNames.includes(fn.toString()));
  }


}

angular
  .module('bringoz.admin.site-preferences')
  .component('packageConfigurationsTableRow', {
    require: {
      form: '^form'
    },
    bindings: {
      index: '<',
      showActions: '<',
      packageConfiguration: '<',
      packageConfigurationCopy: '<',
      isEditable: '<',
      isDefault: '<',
      configurationPackageItems: '<',
      onPackageConfigurationChanged: '&',
      onEditPackageConfigurationClicked: '&',
      onAddNewFieldClicked: '&',
      onDuplicateConfigurationClicked: '&',
    },
    template: require('./package-configurations-table-row.html').default,
    controller: PackageConfigurationsTableRowComponent
  });
